"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStoryStencil = exports.storyStencilDefinition = void 0;
const constraint_model_1 = require("../models/constraints/constraint.model");
const properties_1 = require("../properties");
const editorial_publish_date_property_1 = require("../properties/editorial-publish-date.property");
const editorial_type_property_1 = require("../properties/editorial-type.property");
const playground_property_1 = require("../properties/playground.property");
const playground_project_property_1 = require("../properties/playground-project.property");
const redbullComContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'authorship',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'editorial-type',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'playground-project',
            'playground',
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-photographers',
            'tag-judges',
            'tag-teams',
            'related-content',
        ],
    },
];
const redbulletinContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'authorship',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'editorial-type',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'playground-project',
            'playground',
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-photographers',
            'tag-judges',
            'tag-teams',
            'related-content',
        ],
    },
];
const speedweekContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'authorship',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'editorial-type',
                ],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'related-content',
        ],
    },
];
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'authorship',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'editorial-type',
                ],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
const redBullBoraHansgroheContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'teaser',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'authorship',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'editorial-type',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'editorial-publish-date',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-photographers',
            'tag-judges',
            'tag-teams',
            'related-content',
        ],
    },
];
const redBullBoraHansgroheProperties = {
    [playground_property_1.playgroundPropertyDefinition.name]: {
        ...playground_property_1.playgroundPropertyDefinition,
        constraints: [
            {
                name: 'required',
                argument: false,
            },
        ],
    },
};
const wrcErcProperties = {
    [properties_1.authorshipPropertyDefinition.name]: {
        ...properties_1.authorshipPropertyDefinition,
        constraints: [...properties_1.authorshipPropertyDefinition.constraints],
        default: 'authorship-author',
    },
    [properties_1.authorshipAuthorPropertyDefinition.name]: {
        ...properties_1.authorshipAuthorPropertyDefinition,
        default: 'WRC',
    },
    [properties_1.authorshipLinkPropertyDefinition.name]: {
        ...properties_1.authorshipLinkPropertyDefinition,
        constraints: [
            {
                name: 'stencils',
                argument: ['rally-driver'],
            },
        ],
    },
    [editorial_type_property_1.editorialTypePropertyDefinition.name]: {
        ...editorial_type_property_1.editorialTypePropertyDefinition,
        constraints: [
            {
                name: 'required',
                argument: false,
            },
            editorial_type_property_1.editorialTypePropertyDefinition.constraints[1],
        ],
    },
    [playground_property_1.playgroundPropertyDefinition.name]: {
        ...playground_property_1.playgroundPropertyDefinition,
        constraints: [
            {
                name: 'required',
                argument: false,
            },
        ],
    },
    [properties_1.quoteLinkPropertyDefinition.name]: {
        ...properties_1.quoteLinkPropertyDefinition,
        constraints: [
            {
                name: 'stencils',
                argument: ['rally-driver'],
            },
        ],
    },
    [properties_1.storyContentPropertyDefinition.name]: {
        ...properties_1.storyContentPropertyDefinition,
        constraints: [
            {
                name: 'properties',
                argument: [
                    'text',
                    'headline',
                    'list',
                    'numbered-list',
                    'table',
                    'service-embed',
                    'image',
                    'image-gallery',
                    'results-and-standings',
                    'fact',
                    'couple',
                    'interview',
                    'quote',
                    'accordion',
                    'cta-story-content-container-wrapper',
                ],
            },
        ],
    },
    [properties_1.serviceEmbedPropertyDefinition.name]: {
        ...properties_1.serviceEmbedPropertyDefinition,
        constraints: [
            {
                name: 'providers',
                argument: constraint_model_1.wrcErcServiceEmbedProviders,
            },
        ],
    },
};
exports.storyStencilDefinition = {
    view: {
        label: 'Story',
        category: 'story',
        group: 'Editorial',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'teaser',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'authorship',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'geolocation',
                            'editorial-type',
                        ],
                    },
                    {
                        name: 'Partners',
                        items: ['partner-profiles'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'editorial-publish-date',
                            'standalone',
                            'no-monetization',
                            'sponsored-by',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'playground-project',
                    'playground',
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-photographers',
                    'tag-judges',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.authorshipPropertyDefinition.name]: properties_1.authorshipPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: {
            ...properties_1.ctaContainerPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: ['cta-url'],
                },
            ],
        },
        [properties_1.disciplinesPropertyDefinition.name]: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [editorial_publish_date_property_1.editorialPublishDatePropertyDefinition.name]: editorial_publish_date_property_1.editorialPublishDatePropertyDefinition,
        [editorial_type_property_1.editorialTypePropertyDefinition.name]: editorial_type_property_1.editorialTypePropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.partnerProfilesPropertyDefinition.name]: properties_1.partnerProfilesPropertyDefinition,
        [playground_project_property_1.playgroundProjectPropertyDefinition.name]: playground_project_property_1.playgroundProjectPropertyDefinition,
        [playground_property_1.playgroundPropertyDefinition.name]: playground_property_1.playgroundPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialMediaImagePropertyDefinition.name]: properties_1.socialMediaImagePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.sponsoredByPropertyDefinition.name]: properties_1.sponsoredByPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.storyContentPropertyDefinition.name]: {
            ...properties_1.storyContentPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: [
                        'text',
                        'headline',
                        'quote',
                        'list',
                        'numbered-list',
                        'table',
                        'service-embed',
                        'image',
                        'image-gallery',
                        'video',
                        'audio',
                        'tip',
                        'fact',
                        'couple',
                        'interview',
                        'accordion',
                        'embedded-content',
                        'results-and-standings',
                        'legal-disclaimer',
                        'info-block-group',
                    ],
                },
            ],
        },
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagJudgesPropertyDefinition.name]: properties_1.tagJudgesPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagPhotographersPropertyDefinition.name]: properties_1.tagPhotographersPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 200,
                },
            ],
        },
        [properties_1.titlePropertyDefinition.name]: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 75,
                },
            ],
        },
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull_com',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'redbullmusic',
        'speedweek',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'story',
    overwrites: [
        {
            condition: 'space',
            argument: 'redbull_com',
            contentAreas: redbullComContentAreas,
            properties: {
                [properties_1.ctaButtonLabelPropertyDefinition.name]: {
                    ...properties_1.ctaButtonLabelPropertyDefinition,
                    view: {
                        ...properties_1.ctaButtonLabelPropertyDefinition.view,
                        style: 'hidden',
                    },
                },
                [properties_1.ctaActionTypePropertyDefinition.name]: {
                    ...properties_1.ctaActionTypePropertyDefinition,
                    constraints: [
                        {
                            name: 'options',
                            argument: [
                                'Subscription promotion',
                                'E-reader promotion',
                                'Hub index promotion',
                            ],
                        },
                    ],
                },
            },
        },
        {
            condition: 'space',
            argument: 'redbulletin',
            contentAreas: redbulletinContentAreas,
            properties: {
                [properties_1.ctaButtonLabelPropertyDefinition.name]: {
                    ...properties_1.ctaButtonLabelPropertyDefinition,
                    view: {
                        ...properties_1.ctaButtonLabelPropertyDefinition.view,
                        style: 'hidden',
                    },
                },
                [properties_1.ctaActionTypePropertyDefinition.name]: {
                    ...properties_1.ctaActionTypePropertyDefinition,
                    constraints: [
                        {
                            name: 'options',
                            argument: [
                                'Subscription promotion',
                                'E-reader promotion',
                                'Hub index promotion',
                            ],
                        },
                    ],
                },
            },
        },
        {
            condition: 'space',
            argument: 'speedweek',
            contentAreas: speedweekContentAreas,
            properties: {
                [playground_property_1.playgroundPropertyDefinition.name]: {
                    ...playground_property_1.playgroundPropertyDefinition,
                    constraints: [
                        {
                            name: 'required',
                            argument: false,
                        },
                    ],
                },
                [properties_1.storyContentPropertyDefinition.name]: {
                    ...properties_1.storyContentPropertyDefinition,
                    constraints: [
                        {
                            name: 'properties',
                            argument: [
                                'text',
                                'headline',
                                'list',
                                'numbered-list',
                                'table',
                                'service-embed',
                                'image',
                                'image-gallery',
                            ],
                        },
                    ],
                },
                [properties_1.serviceEmbedPropertyDefinition.name]: {
                    ...properties_1.serviceEmbedPropertyDefinition,
                    constraints: [
                        {
                            name: 'providers',
                            argument: ['YouTube'],
                        },
                    ],
                },
            },
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
            properties: wrcErcProperties,
        },
        {
            condition: 'space',
            argument: 'erc',
            properties: wrcErcProperties,
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'pro-cycling',
            contentAreas: redBullBoraHansgroheContentAreas,
            properties: redBullBoraHansgroheProperties,
        },
    ],
};
const isStoryStencil = (stencil) => {
    return stencil.name === exports.storyStencilDefinition.name;
};
exports.isStoryStencil = isStoryStencil;
//# sourceMappingURL=data:application/json;base64,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